import type { Project } from "@tudigo-monorepo/core-tudigo-api-models";

const LIMIT = 4;

export function getFormattedParticipationLinkedProjectsNames(
  projects?: Project[] | null,
  limit = LIMIT,
) {
  const linkedProjects =
    projects?.map((project) => project.content?.name ?? "") ?? [];
  let formattedProjectsNames = linkedProjects.slice(0, limit).join(", ");
  const projectsCount = linkedProjects.length;
  const remainingCount = projectsCount > limit ? projectsCount - limit : 0;
  if (remainingCount > 0) {
    formattedProjectsNames += ` +${remainingCount}`;
  }

  return formattedProjectsNames;
}
